import styled from "styled-components";

const NavBarStyled = styled.div`
    position: relative;
    display:flex;
    padding-top: 40px;
    padding-bottom:40px;
    flex-direction: column;
    justify-content: center;
     min-width: 124px;


   
  
`

export default NavBarStyled;